import React from 'react';
import { Clock, Mail, MessageCircle } from 'lucide-react';

function RateLimitNotice({ onClose }) {
  const supportEmail = process.env.REACT_APP_SUPPORT_EMAIL || 'support@paperbrainz.com';

  return (
    <div className="bg-yellow-50 dark:bg-yellow-900/20 border border-yellow-200 dark:border-yellow-800 rounded-lg p-6">
      <div className="flex items-start space-x-3">
        <div className="flex-shrink-0">
          <div className="p-2 bg-yellow-100 dark:bg-yellow-900/30 rounded-lg">
            <Clock className="w-6 h-6 text-yellow-600 dark:text-yellow-400" />
          </div>
        </div>
        <div className="flex-1">
          <h3 className="text-lg font-semibold text-yellow-900 dark:text-yellow-200 mb-2">
            Too Many Attempts
          </h3>
          <p className="text-sm text-yellow-800 dark:text-yellow-300 mb-4">
            For your security, we've temporarily limited login attempts from your location.
            Please wait <strong>15 minutes</strong> before trying again.
          </p>

          <div className="bg-white dark:bg-gray-800 rounded-lg p-4 mb-4 border border-yellow-200 dark:border-yellow-700">
            <p className="text-sm font-medium text-gray-900 dark:text-white mb-2">
              Why did this happen?
            </p>
            <ul className="text-sm text-gray-700 dark:text-gray-300 space-y-1 list-disc list-inside">
              <li>Too many failed login attempts</li>
              <li>Multiple registration attempts</li>
              <li>Security protection against brute force attacks</li>
            </ul>
          </div>

          <div className="space-y-3">
            <p className="text-sm font-medium text-yellow-900 dark:text-yellow-200">
              Need immediate access?
            </p>

            <div className="flex flex-col sm:flex-row gap-3">
              <a
                href={`mailto:${supportEmail}?subject=Rate Limit - Need Assistance&body=Hello, I'm experiencing rate limiting and need assistance accessing my account.`}
                className="flex items-center justify-center space-x-2 px-4 py-2.5 bg-blue-600 hover:bg-blue-700 text-white rounded-lg transition-colors text-sm font-medium"
              >
                <Mail className="w-4 h-4" />
                <span>Email Support</span>
              </a>

              <a
                href="https://twitter.com/YourCompany"
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center justify-center space-x-2 px-4 py-2.5 bg-gray-100 dark:bg-gray-700 hover:bg-gray-200 dark:hover:bg-gray-600 text-gray-900 dark:text-white rounded-lg transition-colors text-sm font-medium"
              >
                <MessageCircle className="w-4 h-4" />
                <span>Live Chat</span>
              </a>
            </div>

            <p className="text-xs text-gray-600 dark:text-gray-400">
              Our support team typically responds within 1-2 hours during business hours.
            </p>
          </div>

          {onClose && (
            <button
              onClick={onClose}
              className="mt-4 text-sm text-yellow-800 dark:text-yellow-300 hover:text-yellow-900 dark:hover:text-yellow-200 underline"
            >
              Dismiss
            </button>
          )}
        </div>
      </div>
    </div>
  );
}

export default RateLimitNotice;
